var v = "5.8.1";
var fr = 29.9700012207031;
var ip = 0;
var op = 120.0000048877;
var w = 468;
var h = 468;
var nm = "user 3";
var ddd = 0;
var assets = [];
var layers = [
    {
        ddd: 0,
        ind: 1,
        ty: 4,
        nm: "Outer Circle",
        sr: 1,
        ks: {
            o: {
                a: 1,
                k: [
                    {
                        i: {
                            x: [
                                0.34
                            ],
                            y: [
                                1
                            ]
                        },
                        o: {
                            x: [
                                0.66
                            ],
                            y: [
                                0
                            ]
                        },
                        t: 0,
                        s: [
                            0
                        ]
                    },
                    {
                        t: 13.0000005295009,
                        s: [
                            100
                        ]
                    }
                ],
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    233.762,
                    233.748,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: 0.478,
                                y: 1
                            },
                            o: {
                                x: 0.52,
                                y: 0
                            },
                            t: 3,
                            s: [
                                {
                                    i: [
                                        [
                                            -0.413,
                                            0
                                        ],
                                        [
                                            0,
                                            -0.413
                                        ],
                                        [
                                            0.413,
                                            0
                                        ],
                                        [
                                            0,
                                            0.413
                                        ]
                                    ],
                                    o: [
                                        [
                                            0.413,
                                            0
                                        ],
                                        [
                                            0,
                                            0.413
                                        ],
                                        [
                                            -0.413,
                                            0
                                        ],
                                        [
                                            0,
                                            -0.413
                                        ]
                                    ],
                                    v: [
                                        [
                                            0,
                                            -0.748
                                        ],
                                        [
                                            0.748,
                                            0
                                        ],
                                        [
                                            0,
                                            0.748
                                        ],
                                        [
                                            -0.748,
                                            0
                                        ]
                                    ],
                                    c: true
                                }
                            ]
                        },
                        {
                            t: 22.0000008960784,
                            s: [
                                {
                                    i: [
                                        [
                                            -52.476,
                                            0
                                        ],
                                        [
                                            0,
                                            -52.476
                                        ],
                                        [
                                            52.476,
                                            0
                                        ],
                                        [
                                            0,
                                            52.476
                                        ]
                                    ],
                                    o: [
                                        [
                                            52.476,
                                            0
                                        ],
                                        [
                                            0,
                                            52.476
                                        ],
                                        [
                                            -52.476,
                                            0
                                        ],
                                        [
                                            0,
                                            -52.476
                                        ]
                                    ],
                                    v: [
                                        [
                                            0,
                                            -95.017
                                        ],
                                        [
                                            95.017,
                                            0
                                        ],
                                        [
                                            0,
                                            95.017
                                        ],
                                        [
                                            -95.017,
                                            0
                                        ]
                                    ],
                                    c: true
                                }
                            ]
                        }
                    ],
                    ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
            },
            {
                ty: "st",
                c: {
                    a: 0,
                    k: [
                        0.525490224361,
                        0.450980395079,
                        0.705882370472,
                        1
                    ],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 19.003,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                bm: 0,
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    },
    {
        ddd: 0,
        ind: 2,
        ty: 4,
        nm: "Shoulders",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    233.462,
                    234.008,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        hasMask: true,
        masksProperties: [
            {
                inv: false,
                mode: "a",
                pt: {
                    a: 0,
                    k: {
                        i: [
                            [
                                -52.476,
                                0
                            ],
                            [
                                0,
                                -52.476
                            ],
                            [
                                52.476,
                                0
                            ],
                            [
                                0,
                                52.476
                            ]
                        ],
                        o: [
                            [
                                52.476,
                                0
                            ],
                            [
                                0,
                                52.476
                            ],
                            [
                                -52.476,
                                0
                            ],
                            [
                                0,
                                -52.476
                            ]
                        ],
                        v: [
                            [
                                -2.5,
                                -85.517
                            ],
                            [
                                92.517,
                                9.5
                            ],
                            [
                                -2.5,
                                104.517
                            ],
                            [
                                -97.517,
                                9.5
                            ]
                        ],
                        c: true
                    },
                    ix: 1,
                    x: "var $bm_rt;\n$bm_rt = thisComp.layer('Outer Circle').content('Path 1').path;"
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 3
                },
                x: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                nm: "Mask 1"
            }
        ],
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        32.081,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        -32.081
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -32.081,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        32.081
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -32.081,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        32.081
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        32.081,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        -32.081
                                    ]
                                ],
                                v: [
                                    [
                                        14.236,
                                        22.624
                                    ],
                                    [
                                        -16.313,
                                        22.624
                                    ],
                                    [
                                        -74.4,
                                        80.711
                                    ],
                                    [
                                        -74.4,
                                        89.477
                                    ],
                                    [
                                        -16.313,
                                        147.564
                                    ],
                                    [
                                        14.236,
                                        147.564
                                    ],
                                    [
                                        72.323,
                                        89.477
                                    ],
                                    [
                                        72.323,
                                        80.711
                                    ]
                                ],
                                c: true
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 1,
                            k: [
                                {
                                    i: {
                                        x: 0.667,
                                        y: 1
                                    },
                                    o: {
                                        x: 0.333,
                                        y: 0
                                    },
                                    t: 5,
                                    s: [
                                        1,
                                        91
                                    ],
                                    to: [
                                        0,
                                        -15.167
                                    ],
                                    ti: [
                                        0,
                                        15.167
                                    ]
                                },
                                {
                                    t: 22.0000008960784,
                                    s: [
                                        1,
                                        0
                                    ]
                                }
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 1,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            },
            {
                ty: "st",
                c: {
                    a: 0,
                    k: [
                        0.525490224361,
                        0.450980395079,
                        0.705882370472,
                        1
                    ],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 19.003,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                bm: 0,
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
            },
            {
                ty: "fl",
                c: {
                    a: 0,
                    k: [
                        0.972549019608,
                        0.949019607843,
                        0.972549019608,
                        1
                    ],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                bm: 0,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    },
    {
        ddd: 0,
        ind: 3,
        ty: 4,
        nm: "head",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    233.462,
                    234.008,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        hasMask: true,
        masksProperties: [
            {
                inv: false,
                mode: "a",
                pt: {
                    a: 0,
                    k: {
                        i: [
                            [
                                -52.476,
                                0
                            ],
                            [
                                0,
                                -52.476
                            ],
                            [
                                52.476,
                                0
                            ],
                            [
                                0,
                                52.476
                            ]
                        ],
                        o: [
                            [
                                52.476,
                                0
                            ],
                            [
                                0,
                                52.476
                            ],
                            [
                                -52.476,
                                0
                            ],
                            [
                                0,
                                -52.476
                            ]
                        ],
                        v: [
                            [
                                -2.5,
                                -85.517
                            ],
                            [
                                92.517,
                                9.5
                            ],
                            [
                                -2.5,
                                104.517
                            ],
                            [
                                -97.517,
                                9.5
                            ]
                        ],
                        c: true
                    },
                    ix: 1,
                    x: "var $bm_rt;\n$bm_rt = thisComp.layer('Outer Circle').content('Path 1').path;"
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 3
                },
                x: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                nm: "Mask 1"
            }
        ],
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        d: 1,
                        ty: "el",
                        s: {
                            a: 0,
                            k: [
                                65,
                                65
                            ],
                            ix: 2
                        },
                        p: {
                            a: 0,
                            k: [
                                0,
                                -11
                            ],
                            ix: 3
                        },
                        nm: "Ellipse Path 1",
                        mn: "ADBE Vector Shape - Ellipse",
                        hd: false
                    },
                    {
                        ty: "gr",
                        it: [
                            {
                                ty: "tr",
                                p: {
                                    a: 0,
                                    k: [
                                        0,
                                        0
                                    ],
                                    ix: 2
                                },
                                a: {
                                    a: 0,
                                    k: [
                                        0,
                                        0
                                    ],
                                    ix: 1
                                },
                                s: {
                                    a: 0,
                                    k: [
                                        100,
                                        100
                                    ],
                                    ix: 3
                                },
                                r: {
                                    a: 0,
                                    k: 0,
                                    ix: 6
                                },
                                o: {
                                    a: 0,
                                    k: 100,
                                    ix: 7
                                },
                                sk: {
                                    a: 0,
                                    k: 0,
                                    ix: 4
                                },
                                sa: {
                                    a: 0,
                                    k: 0,
                                    ix: 5
                                },
                                nm: "Transform"
                            }
                        ],
                        nm: "Group 1",
                        np: 0,
                        cix: 2,
                        bm: 0,
                        ix: 2,
                        mn: "ADBE Vector Group",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 1,
                            k: [
                                {
                                    i: {
                                        x: 0.667,
                                        y: 1
                                    },
                                    o: {
                                        x: 0.333,
                                        y: 0
                                    },
                                    t: 8,
                                    s: [
                                        1,
                                        131
                                    ],
                                    to: [
                                        0,
                                        -21.833
                                    ],
                                    ti: [
                                        0,
                                        21.833
                                    ]
                                },
                                {
                                    t: 24.00000097754,
                                    s: [
                                        1,
                                        0
                                    ]
                                }
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            },
            {
                ty: "st",
                c: {
                    a: 0,
                    k: [
                        0.525490224361,
                        0.450980395079,
                        0.705882370472,
                        1
                    ],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 19.003,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                bm: 0,
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    },
    {
        ddd: 0,
        ind: 4,
        ty: 4,
        nm: "Bgrnd",
        sr: 1,
        ks: {
            o: {
                a: 1,
                k: [
                    {
                        i: {
                            x: [
                                0.34
                            ],
                            y: [
                                1
                            ]
                        },
                        o: {
                            x: [
                                0.66
                            ],
                            y: [
                                0
                            ]
                        },
                        t: 0,
                        s: [
                            0
                        ]
                    },
                    {
                        t: 13.0000005295009,
                        s: [
                            100
                        ]
                    }
                ],
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    233.836,
                    233.167,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        125.943
                                    ],
                                    [
                                        125.943,
                                        0
                                    ],
                                    [
                                        0,
                                        -125.943
                                    ],
                                    [
                                        -125.943,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        125.943,
                                        0
                                    ],
                                    [
                                        0,
                                        -125.943
                                    ],
                                    [
                                        -125.943,
                                        0
                                    ],
                                    [
                                        0,
                                        125.943
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        0,
                                        228.04
                                    ],
                                    [
                                        228.04,
                                        0
                                    ],
                                    [
                                        0,
                                        -228.04
                                    ],
                                    [
                                        -228.04,
                                        0
                                    ],
                                    [
                                        0,
                                        228.04
                                    ]
                                ],
                                c: true
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "fl",
                        c: {
                            a: 0,
                            k: [
                                0.972549021244,
                                0.949019610882,
                                0.972549021244,
                                1
                            ],
                            ix: 4
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 5
                        },
                        r: 1,
                        bm: 0,
                        nm: "Fill 1",
                        mn: "ADBE Vector Graphic - Fill",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    }
];
var markers = [];
var User = {
    v: v,
    fr: fr,
    ip: ip,
    op: op,
    w: w,
    h: h,
    nm: nm,
    ddd: ddd,
    assets: assets,
    layers: layers,
    markers: markers
};

export { assets, ddd, User as default, fr, h, ip, layers, markers, nm, op, v, w };
//# sourceMappingURL=User.json.es.js.map
